export const environment = {
  production: false,
  apiUrl: 'https://dev.adminseaf.com', // o con /auth si tu backend espera eso
  version: '1.4.4'
};
